import baseModule from '@/store/shared/graphql'
import api from '@/api/exportLog/details'

const STORE_TYPE = 'EXPORT_LOG_DETAILS'
const API_DATA_KEY = 'activityLogDetails'
const API_DATA_BY_ID_KEY = 'batchId'
const defaultModule = baseModule(STORE_TYPE, API_DATA_BY_ID_KEY, API_DATA_KEY, api)

export default {
    state: {
        ...defaultModule.state,
    },
    getters: {
        ...defaultModule.getters,
    },
    mutations: {
        ...defaultModule.mutations,
    },
    actions: {
        ...defaultModule.actions,
    },
    namespaced: true,
}
